import { UrlApi } from "../../../services/apirest";

const parseJsonSafe = async (res) => {
  try {
    return await res.json();
  } catch {
    return null;
  }
};

export async function listarPlantillasCorreo() {
  const res = await fetch(`${UrlApi}/plantillas-correo`);
  const data = await parseJsonSafe(res);
  if (!res.ok || data?.ok === false) {
    throw new Error(data?.msg || "No se pudieron obtener las plantillas");
  }
  return Array.isArray(data?.data) ? data.data : [];
}

export async function obtenerPlantillaCorreo(codigo) {
  const lista = await listarPlantillasCorreo();
  return lista.find((item) => item.codigo === codigo) || null;
}

export async function guardarPlantillaCorreo(
  codigo,
  { asunto, texto_arriba, texto_abajo }
) {
  const usuario = localStorage.getItem("user") || null;
  const res = await fetch(`${UrlApi}/plantillas-correo/${codigo}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      asunto,
      texto_arriba,
      texto_abajo,
      usuario,
    }),
  });
  const data = await parseJsonSafe(res);
  if (!res.ok || data?.ok === false) {
    throw new Error(data?.msg || "No se pudo guardar la plantilla");
  }
  return data?.data;
}
